<template>
  <table-render ref="tableRender" :config="config" />
</template>

<script>
import tableRender from '@/components/tableRender';
import { roleManagement as config } from './config';
export default {
  name: 'RoleManagement',
  data() {
    return {
      config
    };
  },
  components: { tableRender },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
